module.exports = __webpack_public_path__ + "img/dlybg05.6264e89b.png";